module.exports = __webpack_public_path__ + "img/jamaica.8a8dbeed.svg";